module.exports = __webpack_public_path__ + "img/logo.162400a7.png";